import { qs, qsa } from './util';
import { emitSegment } from './segment/emitSegment';

let isiPhone = /iPad|iPhone|iPod/.test(navigator.userAgent);
if (isiPhone) $('#sameday-settlements .bg').addClass('ios');

// load animation using lottie

bodymovin.loadAnimation({
  container: qs('#banner-lottie'),
  renderer: 'svg',
  loop: true,
  autoplay: true,
  path:
    'https://cdn.razorpay.com/static/assets/razorpay.com/capital/instant-settlements/banner-lottie.json'
});

bodymovin.loadAnimation({
  container: qs('#loan-hero-illustration-lottie'),
  renderer: 'svg',
  loop: true,
  autoplay: true,
  path:
    'https://cdn.razorpay.com/static/assets/razorpay.com/capital/instant-settlements/amount-settlement-lottie.json'
});

// Zapier form submit

$('#marketplaces-waitlist').submit(function(e) {
  e.preventDefault();
  $.ajax({
    url: 'https://hooks.zapier.com/hooks/catch/7687683/bykv87h/',
    method: 'POST',
    data: $(this).serialize(),
    success: function(data) {
      $('#marketplaces-waitlist button').addClass('success');
      $('#marketplaces-waitlist button').text('');
    }
  });
});

// Scroll on view demo click

qs('.ctas .view-demo').addEventListener('click', e => {
  let targetElm = e.currentTarget.getAttribute('href');
  qs(targetElm).scrollIntoView({ behavior: 'smooth' });
});

// Segement Tracking Events

qs('#banner .sign-up-now').addEventListener('click', () => {
  const isMobile = window.innerWidth < 769;
  emitSegment('Sign up CTA clicked', {
    pageUrl: window.location.href,
    device_type: isMobile ? 'Mobile DWeb' : 'DWeb',
    fold: 'banner', // backward compatibity, hence forth use location instaed of fold.
    location: 'banner',
    source: isMobile ? 'Mobile Website' : 'Website',
    slug: window.location.origin + window.location.pathname,
    mode: 'null',
    userRole: 'null',
    userId: 'null',
    merchantId: 'null'
  });
});

qs('#banner .view-demo').addEventListener('click', () => {
  emitSegment('ES demo video CTA clicked');
});

qs('#api-doc-btn').addEventListener('click', () => {
  emitSegment('ES API Documentation CTA clicked');
});

qs('#video-section #go-to-dashboard-btn').addEventListener('click', () => {
  emitSegment('ES dashboard CTA clicked');
});

qs('#endsection-btn').addEventListener('click', () => {
  emitSegment('ES bottom fold CTA click');
});

qsa('#faqs .faqs-tab-title').forEach((node, idx) => {
  node.addEventListener('click', function(e) {
    emitSegment(`ES FAQ question ${idx + 1} click`);
  });
});
